import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { ScrollContainer } from '../../scroll-container/ScrollContainer';
import { ExpandableScrollContainer } from '@gift/ui/components/scroll-container/ExpandableScrollContainer';
import styles from './AccordionMenu.module.scss';

export const AccordionMenu = ({
    children, active, className, isExpandable = false, height = 360
}: Props) => {

    if (!active) {
        return null;
    }

    const classes = classNames(className, styles.default);

    return (
        <>
            {isExpandable ? (
                <ExpandableScrollContainer initialHeight={height} className={classes}>
                    {children}
                </ExpandableScrollContainer>
            ) : (
                <ScrollContainer maxHeight={height} className={classes}>
                    {children}
                </ScrollContainer>
            )}
        </>
    );
};

type Props = PropsWithChildren<{
    active: boolean;
    className?: string;
    isExpandable?: boolean;
    height?: number;
}>;
